export default {
  label: "Proyectos",
  deleteProject: "Eliminar Proyecto",
  deleteProjectErrorMessage:
    "Este proyecto no puede ser eliminado ya que existen uno o más activos para el proyecto. Por favor asígnalos a otro proyecto primero.",
  deleteProjectMessage: "¿Realmente quieres eliminar el proyecto?",
};
